<template>
  <v-layout>
    <v-dialog v-model="isDialog" width="68%" height="50%">
      <!--  :style="dialogStyle"
      hide-overlay transition="dialog-bottom-transition"
      -->
      <v-card :style="myStyle">
        <v-toolbar dark color="#004884" height="40">
          <v-toolbar-title>{{ 'TITLE_FORMEL' | translate }} {{getYear()}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="!isMaximized" icon dark @click="toggleSize()">
            <v-icon small>fa-window-maximize</v-icon>
          </v-btn>
          <v-btn v-if="isMaximized" icon dark @click="toggleSize()">
            <v-icon small>fa-window-minimize</v-icon>
          </v-btn>

          <v-btn icon dark @click="isDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-dialog v-model="ecDialog.show" max-width="500px" @close="ecDialog.show = false" style="display: inline">
          <v-card>
            <v-card-text>
              <span v-if="ecDialog.menuData && ecDialog.menuData.ec">
                {{ 'TITLE_EC_COMMENT' | translate}}
              </span>
              <span v-if="ecDialog.menuData && ecDialog.menuData.ec">
                {{ecDialog.menuData.ec}}
              </span>
              <br>
              <span v-if="ecDialog.menuData && ecDialog.menuData.bc">
                {{ 'TITLE_BC_COMMENT' | translate}}
              </span>
              <span v-if="ecDialog.menuData && ecDialog.menuData.bc">
                {{ecDialog.menuData.bc}}
              </span>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-layout row wrap class="justify-center">
          <v-flex xs12 class="text-xs-right pt-2">
            <div style="border:1px solid white;max-width: 80px; float:right; margin-right: 40px; padding: 5px;">
              <span style="color:#004884; white-space: nowrap;">{{currentCurrencyName}} / {{currencyDimensionName}}</span>
              <!-- <v-icon small class="pr-2" color="#004884">error_outline</v-icon> -->
            </div>
          </v-flex>
          <v-flex xs12 sm8 v-if="formelDetail && formelDetail.infoText">
            <v-icon>alert</v-icon>
            <span class="infoText">{{ formelDetail.infoText}}</span>
          </v-flex>
          <v-flex xs12 class="px-4 pt-0">
            <v-card-text :key="kennZahlFormelIndex">
              <v-layout row wrap class="justify-start">
                <v-flex xs12 v-if="formelDetail">
                  <v-layout row wrap class="kennZahlFormel">
                    <v-flex xs6 class="kennZahlFormelTitle text-xs-left">
                      <span><span class="kennZahlFormelType" v-if="formelDetail">{{formelDetail.typeName}}</span><sub :class="commentClass">{{ formelDetail.id }}</sub>{{ formelDetail.title }}</span>
                    &nbsp;<span v-if="showValue && formelDetail.value" class="countertitle">(</span>
                      <span v-if="showValue && formelDetail.value" class="countertitle" style="font-weight: 600;color: #8ACAC1;">{{ format(formelDetail.value, formelDetail) }}</span>
                      <span v-if="showValue && formelDetail.value" class="countertitle">)</span>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs3 class="text-xs-right">
                      <v-layout row wrap>
                        <v-btn icon @click="toggleHead()">
                          <v-icon color="#004884">font_download</v-icon>
                        </v-btn>
                        <v-btn icon @click="toggleValue()" v-if="!hideValue">
                          <v-icon color="#004884">toll</v-icon>
                        </v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="hasComment(formelDetail) && !hideValue" justify-start>
                    <v-flex xs12 class="pb-1" justify-start>
                      <v-card style="margin-top: -17px" flat color="transparent">
                        <v-card-text class="text-xs-left pt-1 pb-4" style="font-weight: 600">
                          <div class="commentsSP pa-1" style="width: 30px;"></div>
                          <span v-if="formelDetail.erfassungsformel" class="pl-2">
                            {{ 'TITLE_EC_COMMENT'| translate}}
                          </span>
                          <span v-if="formelDetail.erfassungsformel" class="pl-2">
                            {{formelDetail.erfassungsformel}}
                          </span>
                          <br v-if="formelDetail.erfassungsformel">
                          <span v-if="formelDetail.bilanzkommentar" class="pl-2">
                            {{ 'TITLE_BC_COMMENT'| translate}}
                          </span>
                          <span v-if="formelDetail.bilanzkommentar" class="pl-2">
                            {{formelDetail.bilanzkommentar}}
                          </span>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="kennZahlFormel pb-3" v-if="formulas" justify-start v-for="myFormel in formulas" v-bind:key="myFormel.id">
                    <v-flex xs12 class="pb-1" justify-start>
                      <span v-if="myFormel.name">{{myFormel.name}}</span>
                    <span v-if="myFormel && myFormel.counter">
                      <span v-for="(counter, c) in myFormel.counter" v-bind:key="c" :class="classFor(counter)" @click="addChild(myFormel.counter, counter, -1, myFormel.denominator)">
                        <span v-if="counter.operator && !(counter.operator ==='+' && c ===0)" class="countertitle counterOperator"> {{counter.operator}}</span>
                        <span v-if="counter.id" class="counterText">
                          <sub :class="classForSP('counterSP', counter)">{{ counter.id }}</sub>
                          <span :style="getTextStyle(counter)" v-if="showHead" :class="classFor(counter)">{{ counter.text }}</span>
                          <span v-if="showValue && counter.value" class="countertitle">(</span>
                          <span v-if="showValue && counter.value" class="counter countertitle"
                                style="font-weight: 600;color: #8ACAC1;">{{ format(counter.value, counter) }}</span>
                          <span v-if="showValue && counter.value" class="countertitle">)</span>
                        </span>
                        <span v-if="counter.factor && !(counter.factor === 1)" class="countermal"> x {{counter.factor}}</span>

                        <!--<span v-if="!counter.sp && !showHead" v-html="counter.text" class="countermal mx-1" :style="getTextStyle(counter)"></span>-->

                      </span>
                    </span>
                    </v-flex>
                    <v-flex xs12 class="pa-0" v-if="myFormel && myFormel.denominator && myFormel.denominator.length > 0">
                      <div
                        style="border-top: 1px solid black; margin-top:5px; margin-bottom:5px;width:50%;margin-left: auto; margin-right: auto">

                      </div>
                    </v-flex>
                    <v-flex v-if="myFormel && myFormel.denominator" justify-start>
                    <span v-if="myFormel && myFormel.denominator">
                      <span v-for="(denominator, d) in myFormel.denominator" v-bind:key="d" :class="classFor(denominator)" @click="addChild(myFormel.denominator, denominator, -1, myFormel.counter)">
                        <span v-if="denominator.operator && !(denominator.operator ==='+' && d ===0)" class="countertitle counterOperator"> {{denominator.operator}}</span>
                        <span v-if="denominator.id" class="denominatorText">
                          <sub :class="classForSP('denominatorSP', denominator)">{{ denominator.id }}</sub>
                          <span :style="getTextStyle(denominator)" v-if="showHead" :class="classFor(denominator)">{{ denominator.text }}</span>
                          <span v-if="showValue && denominator.value" class="countertitle">(</span>
                          <span v-if="showValue && denominator.value" class="counter countertitle"
                                style="font-weight: 600;color: #8ACAC1;">{{ format(denominator.value, denominator) }}</span>
                          <span v-if="showValue && denominator.value" class="countertitle">)</span>
                          </span>
                        <span v-if="!denominator.id" v-html="denominator.text" class="denominator mx-1"
                              :style="getTextStyle(denominator)"></span>
                        <span v-if="denominator.factor && !(denominator.factor === 1)" class="countermal"> x {{denominator.factor}}</span>
                      </span>
                    </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="justify-start">
                <v-flex xs12 v-if="formelSet && formelSet.kennZahlFormel">
                  <v-expansion-panel v-model="formelSet.expandDetailPanel" expand>
                    <v-expansion-panel-content v-for="(formulas, i) in formelSet.kennZahlFormel" v-bind:key="i" class="pa-4">
                      <template v-slot:header>
                        <span class="kennZahlFormelTitle" v-if="formulas && formulas.formel"><span class="kennZahlFormelType">{{formulas.formel.typeName}}</span> <sub class="counterSP">{{ formulas.formel.id }}</sub> {{ formulas.formel.title }}</span>
                      </template>
                      <v-card v-for="formel in formulas.formel.formulas" v-bind:key="i + '-' + formel.id">
                        <v-flex xs12 v-if="formel" class="pt-2">
                          <v-layout row wrap class="kennZahlFormel" justify-start>
                            <span class="endformel" v-if="formel.name">{{ formel.name }}</span>
                            <v-flex xs12 class="pb-2" justify-start>
                              <span v-if="formel.counter">
                                <span v-for="(counter, c) in formel.counter" v-bind:key="c">
                                  <span v-if="counter.operator && !(counter.operator ==='+' && c ===0)" class="countertitle counterOperator"> {{counter.operator}}</span>
                                  <span v-if="counter.id" :class="classFor(counter)"
                                        @click="addChild(formel.counter, counter, i, formulas)"><sub :class="classForSP('counterSP', counter)">{{ counter.id }}</sub><span
                                    :style="getTextStyle(counter)" v-if="showHead" :class="classFor(counter)">{{ counter.text }}</span></span>
                                  <span v-if="!counter.id && showHead" v-html="counter.text" class="counter mx-1"
                                        :style="getTextStyle(counter)"></span>
                                  <span v-if="showValue && counter.value" class="countertitle">(</span>
                                  <span v-if="showValue && counter.value" class="counter countertitle" style="font-weight: 600;color: #8ACAC1;">{{ format(counter.value, counter) }}</span>
                                  <span v-if="showValue && counter.value" class="countertitle">)</span>

                                  <span v-if="counter.factor && !(counter.factor === 1)" class="countermal"> x {{counter.factor}}</span>
                                </span>
                              </span>
                            </v-flex>
                            <v-flex xs12 class="pa-0" v-if="formel && formel.denominator && formel.denominator.length > 0">
                              <div
                                style="border-top: 1px solid black; margin-top:5px; margin-bottom:5px;width:50%;margin-left: auto; margin-right: auto">
                              </div>
                            </v-flex>
                            <v-flex v-if="formel.denominator" justify-start class="pt-2">
                        <span v-if="formel.denominator" :style="getKZStyle(formel)">
                          <span v-for="(denominator, d) in formel.denominator" v-bind:key="d">
                                  <v-dialog v-model="denominator.menu" max-width="500px" :close-on-content-click="false" style="display: inline" v-if="hasComment(denominator)">
                                    <v-card>
                                      <v-card-text>
                                      <span v-if="denominator.menuData && denominator.menuData.ec">
                                        {{ 'TITLE_EC_COMMENT'| translate}}
                                      </span>
                                      <span v-if="denominator.menuData && denominator.menuData.ec">
                                          {{counter.menuData.ec}}
                                      </span>
                                      <br>
                                      <span v-if="denominator.menuData && denominator.menuData.bc">
                                        {{ 'TITLE_BC_COMMENT'| translate}}
                                      </span>
                                      <span v-if="denominator.menuData && denominator.menuData.bc">
                                          {{counter.menuData.bc}}
                                      </span>
                                      </v-card-text>
                                  </v-card>
                                  </v-dialog>

                            <span v-if="denominator.operator && !(denominator.operator ==='+' && d ===0)" class="countertitle"> {{denominator.operator}}</span>
                            <span v-if="denominator.id" :class="classFor(denominator)"
                                  @click="addChild(formel.denominator, denominator, i, formulas)"
                                  class="denominatorText"><sub :class="classForSP('denominatorSP', denominator)">{{ denominator.id }}</sub><span
                              :style="getTextStyle(denominator)" :class="classFor(denominator)">{{ denominator.text }}</span></span>
                            <span v-if="!denominator.id && showHead" v-html="denominator.text" class="denominator mx-1"
                                  :style="getTextStyle(denominator)"></span>
                            <span v-if="showValue && denominator.value" class="countertitle">(</span>
                            <span v-if="showValue && denominator.value" class="counter countertitle" style="font-weight: 600;color: #8ACAC1;">{{ format(denominator.value, denominator) }}</span>
                            <span v-if="showValue && denominator.value" class="countertitle">)</span>

                            <span v-if="denominator.factor && !(denominator.factor === 1)" class="countermal"> x {{denominator.factor}}</span>
                          </span>
                        </span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>
              <div :key="kennZahlFormelIndex" v-if="false">
              </div>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import FormelView from "../../widgets/FormelView";
import Vue from "vue";

export default {
  name: 'DialogKennzahlen',
  components: {FormelView, Swiper, SwiperSlide},
  props: ['balance'],
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  data () {
    return {
      dialogStyle: 'height: 80%; width: 80%',
      currentCurrency: '1',
      currencyDimension: '1',
      currencyDimensionName: '',
      currentCurrencyName: '',
      isMaximized: true,
      formulas: [],
      labelFormulas: Vue.i18n.translate('LABEL_VIEW_FORMULAS'),
      ecDialog: {
        show: false,
        menuData: {}
      },
      api: require('@/components/api/kennzahlApi.js').default,
      currentIndex: -1,
      items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Link 1',
          disabled: false,
          href: 'breadcrumbs_link_1'
        },
        {
          text: 'Link 2',
          disabled: true,
          href: 'breadcrumbs_link_2'
        }
      ],
      swiperOptions: {
        effect: 'coverflow',
        grabCursor: false,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 200,
          modifier: 1,
          slideShadows : true
        },
        pagination: {
          el: '.swiper-pagination'
        }
      },
      cIndex: 0,
      sizes: [
        { width: 100, height: 200, color: 'red' },
        { width: 200, height: 70, color: 'green' },
        { width: 120, height: 170, color: 'red' }
      ],
      isDialog: false,
      myStyle: 'overflow-y: auto;', // ;max-height: 80%; min-height: 80%
      kennZahlFormelIndex: 0,
      showValue: false,
      hideValue: false,
      showHead: true,
      expandDetailPanel: 0,
      myFormel2: {
        guid:1,
        isFraction: true,
        formel: {
          title: '135 Bilanzanalytische Eigenmittelquote (%)',
          value: '199.250,00',
          id: '135'
        },
        counter: [
          {
            guid:2,
            sp: 12,
            text: 'Pensionsrückstellungen und ähnliche langfristige Rückstellungen',
            value: '1.200,00',
            kennZahlFormel: [
              {
                formel: {
                  title: 'Pensionsrückstellungen und ähnliche längerfristige Rückstellungen',
                  id: '12'
                },
                counter: [
                  {text: 'Formel 1:'},
                  {sp: 5110, text: 'Pensionsrückstellungen und ähnliche längerfristige Rückstellungen',
                    kennZahlFormel: [
                      {
                        guid:6,
                        formel: {
                          title: 'Pensionsrückstellungen und ähnliche längerfristige Rückstellungen',
                          id: 'SP5110'
                        },
                        counter: [
                          {text: 'Formel 1:'},
                          {sp: 1, text: 'Bilanzposition 251'}
                        ],
                        isFraction: false,
                        denominator: [
                          {text: 'Formel 2:'},
                          {sp: 1, text: 'Bilanzposition 252'},
                          {text: '+'},
                          {sp: 1, text: 'Bilanzposition 5012'},
                          {text: '-'},
                          {sp: 1, text: 'Bilanzposition 253'},
                        ]
                      }
                    ]},
                ],
                isFraction: false,
                denominator: []
              }
            ]
          },
          {text: '&times; 100',guid:3},
          {text: '+',guid:4},
          {
            sp: 66,guid:5,
            text: 'bereinigtes Eigenkapital',
            value: '800,00',
            kennZahlFormel: [
              {
                guid:6,
                formel: {
                  title: 'bereinigtes Eigenkapital',
                  id: 'SP4000'
                },
                counter: [
                  {sp: '4001', text: 'stille Reserven Spielerwerte',guid:8},
                  {text: '+',guid:4},
                  {sp: '4000', text: 'Haftkapital',guid:8},
                  {text: '+',guid:4},
                  {sp: '4000b', text: 'nachrichtlich: bilanzielles Eigenkapital ',guid:8},
                  {text: '&times; 0',guid:11},
                  {text: '+',guid:4},
                  {text: '....',guid:41}
                ],
                isFraction: false,
                denominator: []
              }
            ]
          },
          {text: '&times; 100',guid:11}
        ],
        denominator: [
          {
            guid:12,
            sp: 2, text: 'Bereinigte Bilanzsumme',
            value: '550,00',
            kennZahlFormel: [
              {
                guid:13,
                formel: {
                  title: 'Bereinigte Bilanzsumme',
                  id: '2'
                },
                counter: [
                  {guid:15,sp: 3000, text: 'bereinigte Bilanzsumme Aktiva',
                    kennZahlFormel: [
                      {
                        guid:20,
                        formel: {
                          title: 'bereinigte Bilanzsumme Aktiva',
                          id: 'SP3000'
                        },
                        counter: [
                          {guid:21, sp: 'sa1000', text: 'Summe Anlagevermögen',
                            kennZahlFormel: [
                              {
                                guid:20,
                                formel: {
                                  title: 'Summe Anlagevermögen',
                                  id: 'SA1000'
                                },
                                counter: [
                                  {guid:21, sp: 'SA1100', text: 'bereinigtes immaterielles Vermögen'},
                                  {text: '+',guid:4},
                                  {guid:22, sp: 'SA1200', text: 'Sachanlagevermögen'},
                                  {text: '+',guid:4},
                                  {guid:22, sp: 'SA1300', text: 'Finanzanlagen'},
                                  {text: '+',guid:4},
                                  {guid:22, sp: 'ta1300', text: 'Guthaben aus Kautionskonto bzw. verpfändetes Guthaben'},
                                ],
                                isFraction: false,
                                denominator: []
                              }
                            ]
                          },
                          {text: '+',guid:4},
                          {guid:22, sp: 'sa11300', text: 'Differenzbetrag Aktiva',
                            kennZahlFormel: [
                              {
                                guid:20,
                                formel: {
                                  title: 'Differenzbetrag Aktiva',
                                  id: 'sa11300'
                                },
                                counter: [
                                  {text: 'Formel 1:',guid:4},
                                  {sp: 1, text: 'Bilanzposition 20304'}
                                ],
                                isFraction: false,
                                denominator: []
                              }
                            ]},
                          {text: '+',guid:4},
                          {guid:22, sp: 'sa2000', text: 'Summe Umlaufvermögen'},
                          {text: '+',guid:4},
                          {guid:22, sp: 'ta1300', text: 'Guthaben aus Kautionskonto bzw. verpfändetes Guthaben'},
                        ],
                        isFraction: false,
                        denominator: []
                      }
                    ]
                  }
                ],
                isFraction: false,
                denominator: []
              }
            ]
          },
          {guid:18,text: '&ndash;'},
          {
            guid:19,sp: 67, text: 'flüssige Mittel',
            value: '600,00',
            kennZahlFormel: [
              {
                guid:20,
                formel: {
                  title: 'flüssige Mittel',
                  id: 'SP67'
                },
                counter: [
                  {
                    guid:21,sp: 'SA2260',text: 'flüssige Mittel',
                    kennZahlFormel: [
                      {
                        guid:20,
                        formel: {
                          title: 'flüssige Mittel',
                          id: 'SA2260'
                        },
                        counter: [
                          {text: 'Formel 1:',guid:4},
                          {sp: 1, text: 'Bilanzposition 167'},
                          {text: '+'},
                          {sp: 1, text: 'Bilanzposition 20605'},
                          {text: '-'},
                          {sp: 1, text: 'Bilanzposition 58169'},
                        ],
                        isFraction: false,
                        denominator: []
                      }
                    ]
                  }
                ],
                isFraction: false,
                denominator: []
              }
            ]
          },
          {guid:25,text: '&ndash;'},
          {
            guid:26,sp: 116, text: 'Grundstücke und Bauten',
            value: '700,00',
            kennZahlFormel: [
              {
                formel: {
                  title: 'Grundstücke und Bauten',
                  id: 'SP116'
                },
                counter: [
                  {guid:27,sp: 'SA1210',text: 'Grundstücke, Bauten',
                    kennZahlFormel: [
                      {
                        guid:20,
                        formel: {
                          title: 'Grundstücke, Bauten',
                          id: 'SA1210'
                        },
                        counter: [
                          {text: 'Formel 1:',guid:4},
                          {sp: 1, text: 'Bilanzposition 23'},
                          {text: '+'},
                          {sp: 1, text: 'Bilanzposition 58168'}
                        ],
                        isFraction: false,
                        denominator: []
                      }
                    ]
                  }
                ],
                isFraction: false,
                denominator: []
              }
            ]
          },
        ]
      },
      myFormelSample: {
        isFraction: true,
        formel: {
          title: 'Gesamt Betrag',
          id: '1'
        },
        counter: [
          {
            sp: 12,
            text: 'Netto',
            kennZahlFormel: [
              {
                formel: {
                  title: 'Gesamt',
                  id: 'SP5110'
                },
                counter: [
                  {text: 'Formel 1'},
                  {sp: 251, text: 'Bilanzposition'}
                ],
                isFraction: false,
                denominator: [
                  {text: 'Formel 2'},
                  {sp: 252, text: 'Bilanzposition'},
                  {text: '+'},
                  {sp: 5012, text: 'Bilanzposition'},
                  {text: '-'},
                  {sp: 253, text: 'Bilanzposition'},
                ]
              }
            ]
          },
          {text: '+'},
          {
            sp: 66, text: 'brutto',
            kennZahlFormel: [
              {
                formel: {
                  title: 'bereinigtes Eigenkapital',
                  id: 'SP66'
                },
                counter: [
                  {text: 'Formel Eigenkapital'},
                  {sp: 251, text: 'Bilanzposition'}
                ],
                isFraction: false,
                denominator: [
                  {text: 'Formel 1'},
                  {sp: 252, text: 'Bilanzposition'}
                ]
              }
            ]
          },
          {text: '&times; 1.19'},
        ],
        denominator: [
          {sp: 2, text: 'Bereinigte Bilanzsumme'},
          {text: '&ndash;'},
          {sp: 67, text: 'flüssige Mittel'},
          {text: '&ndash;'},
          {sp: 116, text: 'Grundstücke und Bauten'},
        ]
      },
      formelSet: {
        expandDetailPanel: [],
        kennZahlFormel: []
      },
      commentClass: 'counterSP',
      formelDetail: {
        title: '',
        value: '',
        id: '-1',
        typeName: ''
      },
      balanceOverwritten: null
    }
  },
  methods: {
    getYear () {
      let year = 2019
      if (this.balance) {
        year = this.balance.year
      }
      if (this.balanceOverwritten) {
        year = this.balanceOverwritten.year
      }
      if (!this.showValue) return ''
      return year
    },
    toggleSize () {
      this.isMaximized = !this.isMaximized
      if (this.isMaximized) {
        // this.dialogStyle = 'height: 80%; width: 80%'
        this.myStyle = 'overflow-y: auto;max-height: 100%; height:' + (window.innerHeight - 100) + 'px;'
      } else {
        //  this.dialogStyle = 'height: 40%; width: 40%'
        this.myStyle = 'overflow-y: auto;max-height: 100%; height:' + (window.innerHeight / 4) + 'px;'
      }
    },
    open (kfzType, kzfId, balanceOverwritten, hideValue) {
      this.myStyle = 'overflow-y: auto;max-height: 100%; height:' + (window.innerHeight - 100) + 'px;'
      let myBalance = this.balance
      this.balanceOverwritten = null
      this.showValue = false
      this.isDialog = true
      this.formelSet.kennZahlFormel = []
      this.currentCurrencyName = Vue.prototype.$api.getI18NCurrency(Vue.prototype.storage.getCurrency()).name
      var cDim = Vue.prototype.$api.getI18NCurrencyDimension(Vue.prototype.storage.getCurrencyDimension())
      this.currencyDimensionName = cDim.name
      if (balanceOverwritten) {
        myBalance = balanceOverwritten
        this.balanceOverwritten = balanceOverwritten
      }
      this.hideValue = hideValue
      if (!this.hideValue) {
        this.showValue = true
      }
      this.api.getKennzahlFormel(!this.hideValue, kzfId, kfzType, myBalance, this.onGetFormel)
    },
    onGetFormel (formel) {
      // formel.bilanzkommentar = 'Kommentar s.g. 109'
      this.formelDetail = {
        title: formel.title,
        value: formel.value,
        type: formel.type,
        typeName: formel.typeName,
        infoText: formel.infoText,
        bilanzkommentar: formel.bilanzkommentar,
        erfassungsformel: formel.erfassungsformel,
        unit: formel.unit,
        id: formel.id
      }
      if (this.hasComment(this.formelDetail) && !this.hideValue) {
        this.commentClass = 'counterSP commentsSP'
      }
      // this.myFormel = null
      this.formulas = formel.formulas
      let idx = 0
      let sLen = this.formulas.length
      _.each(this.formulas, function (c) {
        idx = idx + 1
        c.id = idx
        if (sLen > 1) {
          if (!c.name || c.name.length <= 0) {
            // c.name = 'Formel ' + c.id
          }
        }
      })
    },
    format: function (v, item) {
      if (!v) return ''
      let f = 'f2t'
      if (item && item.unit) {
        if (item.unit === 3) {
          f = 'f0t'
        }
      }
      let value = Vue.prototype.$api.convertToWaimeaDecimal(f, v)
      if (item && item.unit) {
        if (item.unit === 1) {
          value = value + ' %'
        }
      }
      return value
    },
    onGetFormelAppend: function (formel) {
      let idx = 0
      let sLen = formel.formulas.length
      if (formel.formulas && formel.formulas.length > 0) {
        // formel.formulas.push(JSON.parse(JSON.stringify(formel.formulas[0])))
      }
      _.each(formel.formulas, function (c) {
        idx = idx + 1
        c.id = idx
        if (sLen > 1) {
          if (!c.name || c.name.length <= 0) {
            // c.name = 'Formel ' + c.id
          }
        }
      })
      if (formel.formulas && formel.formulas.length > 0) {
        let formelToAppend = {} // formel.formulas
        formelToAppend.formel = {
          title: formel.title,
          value: formel.value,
          type: formel.type,
          typeName: formel.typeName,
          id: formel.id,
          formulas: formel.formulas
        }
        let index = this.currentIndex
        if (index < 0) {
          this.formelSet.kennZahlFormel = []
        } else {
          if (this.formelSet && this.formelSet.kennZahlFormel) {
            this.formelSet.kennZahlFormel = this.formelSet.kennZahlFormel.slice(0, index + 1)
          }
        }
        this.formelSet.kennZahlFormel.push(formelToAppend)
        this.formelSet.expandDetailPanel = []
        for (var i in this.formelSet.kennZahlFormel) {
          this.formelSet.expandDetailPanel.push(true)
        }
      }
    },
    getKZStyle (item) {
      if (item.isFraction) {
        return 'border-top: 1px solid black; margin-top:5px; margin-bottom:5px;'
      }
    },
    onChangeFormel () {
      console.log('myFormel')
      try {
        this.formelSet.kennZahlFormel = []
        this.formelSet.expandDetailPanel = []
      } catch (ee) {
        console.error(ee)
      }
      this.kennZahlFormelIndex = this.kennZahlFormelIndex + 1
    },
    toggleValue () {
      this.showValue = !this.showValue
      // if (!this.showValue) {
      // this.showHead = true
      // }
    },
    toggleHead () {
      this.showHead = !this.showHead
      /*
      if (!this.showHead) {
        this.showValue = true
      } else {
        this.showValue = false
      }
      */
    },
    getTextStyle (item) {
      console.log('getTextStyle', item.text)
      let style = ''
      let textStyle = ['+', '-', '&ndash;']
      let idx = textStyle.indexOf(item.text + '')
      if (idx > -1) {
        style =  'font-size: 18px;font-weight: 600;'
      }
      console.log('getTextStyle', style)
      /*
      let textStyle = ['+', '-', '&ndash;']
      let idx = textStyle.indexOf(item.text + '')
      if (idx > -1) {
        style =  'color: #4C4C4C; font-size: 18px;font-weight: 600;'
      }
      let textStyle2 = ['&times; 100']
      idx = textStyle2.indexOf(item.text + '')
      if (idx > -1) {
        style =  'font-size: 16px;font-weight: 600; color: #004884;'
      }
      let textStyle3 = ['Formel 1:', 'Formel 2:']
      idx = textStyle3.indexOf(item.text + '')
      if (idx > -1) {
        style =  'font-size: 13px;font-weight: 600; color: #B2B2B2; padding-right:20px;text-transform: uppercase;'
      }
      */
      return style
    },
    classForSP (val, item) {
      let c = '' + val
      if (!item) return
      if (item.isBold) {
        c += ' textBold '
      }
      /*
      if (!item.final || this.hasComment(item)) {
        c += 'handpointer clickable'
      }
      */
      return c
    },
    classFor (item) {
      let c = ''
      if (!item) return
      if (item.isBold) {
        c += 'textBold '
      }
      if (!item.final || this.hasComment(item)) {
        c += 'handpointer clickable'
      }
      return c
    },
    hasComment (item) {
      let res = false
      if (item && (item.bilanzkommentar && item.bilanzkommentar.length > 0) || (item.erfassungsformel && item.erfassungsformel.length > 0)) {
        res = true
      }
      console.log('hasComment', [item, res])
      return res
    },
    addChild (parent, item, index, clearFix) {
      console.log('add', item, index, clearFix)
      if (!item) return
      if (index === -1) {
        try {
          _.each(this.formulas, function (formel) {
            if (formel.counter) {
              _.each(formel.counter, function (counter) {
                counter.isBold = false
              })
            }
            if (formel.denominator) {
              _.each(formel.denominator, function (counter) {
                counter.isBold = false
              })
            }
          })
        } catch (eee) {
          console.error(eee)
        }
      }

      if (parent) {
        _.each(parent, function (c) {
          c.isBold = false
        })
      }
      if (clearFix) {
        if (clearFix.formel && clearFix.formel.formulas) {
          try {
            _.each(clearFix.formel.formulas, function (c) {
              _.each(c.counter, function (c) {
                c.isBold = false
              })
              _.each(c.denominator, function (c) {
                c.isBold = false
              })
              c.isBold = false
            })
          } catch (eee) {
          }
        }
        _.each(clearFix, function (c) {
          c.isBold = false
        })
      }
      item.isBold = true
      if (!item.final) {
        this.currentIndex = index
        let myBalance = this.balance
        if (this.balanceOverwritten) {
          myBalance = this.balanceOverwritten
        }
        this.api.getKennzahlFormel(!this.hideValue, item.id, item.type, myBalance, this.onGetFormelAppend)
      }
      if (this.hasComment(item) && !this.hideValue) {
        this.ecDialog.show = true
        this.ecDialog.menuData = {
          ec: item.erfassungsformel,
          bc: item.bilanzkommentar
        }
      }
      /*
      if (index < 0) {
        this.formelSet.kennZahlFormel = []
      } else {
        if (this.formelSet && this.formelSet.kennZahlFormel) {
          this.formelSet.kennZahlFormel = this.formelSet.kennZahlFormel.slice(0, index + 1)
        }
      }
      console.log('add', index, this.formelSet.kennZahlFormel.length)
      if (item.kennZahlFormel && item.kennZahlFormel.length > 0) {
        this.formelSet.kennZahlFormel.push(item.kennZahlFormel[0])
      }
      this.formelSet.expandDetailPanel = []
      for (var i in this.formelSet.kennZahlFormel) {
        this.formelSet.expandDetailPanel.push(true)
      }
      console.log('add', item)
      */
    },
    addChilds (item, myself) {
      console.log('addChilds', item)
      this.kennZahlFormel = []
      let newList = []
      let dIndex = 0
      if (item && item.length > 0) {
        for (var i in item) {
          if (item[i].kennZahlFormel) {
            if (item[i].guid === myself.guid) {
              dIndex = newList.length
            }
            newList.push(item[i].kennZahlFormel[0])
          }
        }
      }
      if (JSON.stringify(newList) !== JSON.stringify(this.kennZahlFormel)) {
        this.kennZahlFormel = []
        this.kennZahlFormel = newList
        this.kennZahlFormelIndex++
      }
      /*
      let cmp = this
      cmp.$nextTick(function () {
        cmp.$refs.mySwiper.$swiper.slideTo(dIndex,1300, false)
      })
       */
    },

    // `@click-slide` event has special treatment for Swiper's loop mode, which is still available in loop mode
    handleClickSlide: function(index, reallyIndex) {
      console.log('Click slide!', index, reallyIndex)
      this.$refs.mySwiper.$swiper.slideTo(index,800, false)
    },
    addFirstChilds (item) {
      console.log('addChilds', item)
      if (item && item.kennZahlFormel && item.kennZahlFormel.length > 0) {
        this.kennZahlFormel.push(item.kennZahlFormel[0])
        this.kennZahlFormelIndex++
        this.expandDetailPanel = []
        for (var i in this.kennZahlFormel) {
          this.expandDetailPanel.push(true)
        }
      }

    }
  },
  mounted () {
  }
}
</script>

<style scoped>

.countermal{
  font-size: 18px;
  font-weight: 600;
  color: #004884;
}

.kennZahlFormel{
  text-align: center;
}
.countertitle{
  font-size: 18px;
  margin-top: -5px;
}

.kennZahlFormelTitle{
  text-transform: uppercase;
  color: #004884;
}

.kennZahlFormelType {
  font-weight: bold;
}

.kennZahlFormelTitle:after {
  content: ".";
  color:transparent;
  border-bottom:#8ACAC1 2px solid;
  width:100%;
  display:block;
  margin:0 auto;
  margin-left: 0px;
  margin-top: -15px;
}

.endformel{
  text-transform: uppercase;
  color: #545454;
  margin-left: 18px;
}
.denominator {
}
.counter {
}
.denominatorText {
  color: black;
  font-weight: lighter;
  font-size: 14px;
}

.counterText {
  color: black;
  font-weight: lighter;
  font-size: 14px;
}
.denominatorSP{
  color: #7F7F7F;
  font-weight: 600;
  font-size: 14px;
}
.counterSP {
  color: #7F7F7F;
  font-weight: 600;
  font-size: 14px;
}
.textBold {
  font-weight: bold !important;
  color:#101010 !important;
}
sub{
  bottom: -0.5em !important;
}
.v-expansion-panel {
  box-shadow: none !important;
}
.clickable {
  color: #3a768f !important;
}
.infoText {
  font-weight: bold;
}

.commentsSP{
  border-left: 1px solid #8ACAC1;
  border-top: 1px solid #8ACAC1;
}
.counterOperator{
  font-size: 18px;
  font-weight: 600;
}

</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogKennzahlen.vue